import { api } from '../api'

import type { Weekend, WeekendPayload, WeekendsQueryParams } from './work-schedules-services-types'

export const weekendsServices = {
  get: async (params: WeekendsQueryParams) => {
    const { data } = await api.get<Weekend[]>('/week-ends/', {
      params
    })
    return data
  },
  add: async (payload: WeekendPayload) => {
    const { data: data } = await api.post<Weekend>('/week-ends/', payload)
    return data
  },
  delete: async (id: number) => {
    const { data: data } = await api.delete<Weekend>(`/week-ends/${id}/`)
    return data
  },
  update: async (id: number, payload: Partial<WeekendPayload>) => {
    const { data: data } = await api.patch<Weekend>(`/week-ends/${id}/`, payload)
    return data
  }
}
